import React, { useRef, useMemo, useEffect } from 'react'

import { Form, FormTextField } from '@/components/CoForm'
import { Box, Dialog, DialogActions, DialogContent } from '@material-ui/core'
import { Link } from 'react-router-dom'

import { placa } from '@/consts/regexp'
import { toMask, unmask } from '@/services/masks'
import { Button } from '@/components'
import { StyledDialogTitle } from '@/components/Dialog/styles'

import { handleValidationError, Yup as y } from '@/services/yup'

import { useDispatch, useSelector } from 'react-redux'
import {
  cancelEditCollect,
  updateCollectRequest,
} from '@/store/modules/users/collections/reducer'
import {
  ComboboxLastDrivers,
  ComboboxLastVehicles,
} from '@/components/Combobox'
import { Alert } from '@material-ui/lab'
import PATHS from '@/consts/paths'

const EditCollectSchema = y.object().shape({
  vpt_placa: y.string().required(),
  vpt_motorista: y.string().required(),
  vpt_cod_motorista: y.string().required(),
})

// -----------------------------------------------------------

export function CollectQuickFormEdit() {
  const activeCollect = useSelector(
    (state) => state.users.collections.active.collectParams
  )

  const isSubmitting = useSelector((state) => state.users.collections.loading)

  const dispatch = useDispatch()

  function handleClose() {
    dispatch(cancelEditCollect())
  }

  const formRef = useRef(null)

  const defaultValues = useMemo(
    () => ({
      id_coleta: activeCollect?.id_coleta || '',
      vpt_placa: activeCollect?.vpt_placa || '',
      vpt_motorista: activeCollect?.vpt_motorista || '',
      vpt_cod_motorista: activeCollect?.vpt_cod_motorista || '',
    }),
    [activeCollect]
  )

  // ---------------------------------------------

  function handleChangeDriver(_, driver) {
    formRef.current.setFieldValue('vpt_motorista', driver.label)
  }

  function handleSubmitButton() {
    formRef.current.setErrors({})

    const data = formRef.current.getValues()
    handleSubmit(data)
  }

  async function handleSubmit(data) {
    const formValidator = handleValidationError(formRef.current)

    EditCollectSchema.validate(data, { abortEarly: false })
      .then((data) => {
        dispatch(updateCollectRequest(data))
        console.log(data)
      })
      .catch((errors) => {
        formValidator(errors)
      })
  }

  // ---------------------------------------------

  useEffect(() => {
    if (formRef.current) {
      formRef.current.setData(defaultValues)
    }
  }, [defaultValues])

  return (
    <Dialog fullWidth maxWidth="sm" open={Boolean(activeCollect.isEditing)}>
      <StyledDialogTitle>Alterar informações da coleta</StyledDialogTitle>

      <DialogContent>
        <Form
          formRef={formRef}
          initialData={defaultValues}
          onSubmit={handleSubmit}
          schema={EditCollectSchema}
        >
          <Box padding="1rem 0" display="grid" gridGap="1rem">
            <RegisterVehicleDriverAlert />

            <FormTextField
              fullWidth
              size="small"
              name="id_coleta"
              label="Coleta"
              variant="outlined"
              disabled
              onChange={() => {}}
            />

            <ComboboxLastVehicles
              fullWidth
              size="small"
              name="vpt_placa"
              label="Placa"
              textMaskProps={toMask(placa.array)}
              disableClearable
            />

            <ComboboxLastDrivers
              fullWidth
              size="small"
              name="vpt_cod_motorista"
              label="Motorista"
              disableClearable
              //
              onAfterChange={handleChangeDriver}
            />
          </Box>
        </Form>
      </DialogContent>

      <DialogActions>
        <Button
          type="button"
          variant="outlined"
          color="primary"
          onClick={handleClose}
        >
          Cancelar
        </Button>

        <Button
          type="button"
          variant="contained"
          color="primary"
          onClick={handleSubmitButton}
          loading={isSubmitting}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

// -------------------------------------------------------------

function RegisterVehicleDriverAlert() {
  const activeCollect = useSelector(
    (state) => state.users.collections.active.collectParams
  )

  const vehicles = useSelector((state) => state.comuns.lastVehicles.vehicles)
  const drivers = useSelector((state) => state.comuns.lastDrivers.drivers)

  const driverAlreadyRegister = useMemo(() => {
    return drivers.some(
      (driver) =>
        unmask(driver.wem_cpf) === unmask(activeCollect.vpt_cod_motorista)
    )
  }, [])

  const vehicleAlreadyRegister = useMemo(() => {
    return vehicles.some(
      (vehicle) => unmask(vehicle.wev_placa) === unmask(activeCollect.vpt_placa)
    )
  }, [])

  if (driverAlreadyRegister && vehicleAlreadyRegister) {
    return null
  }

  return (
    <Alert severity="warning">
      Placa ou motorista não cadastrados,{' '}
      <Link to={PATHS.user.register}>Clique para cadastrar.</Link>
    </Alert>
  )
}
